import { render, staticRenderFns } from "./DownloadTemplate.vue?vue&type=template&id=2d8849fa&scoped=true&"
import script from "./DownloadTemplate.vue?vue&type=script&lang=js&"
export * from "./DownloadTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTemplate.vue?vue&type=style&index=0&id=2d8849fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8849fa",
  null
  
)

export default component.exports